import React from "react";
import { CRMCardOutside } from "../../components/CRMCardOutside/CRMCardOutside";
import { CRMSpacing } from "../../models/CRMSpacing";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { SpacingColumn } from "../../components/BuildingBlocks/SpacingColumn";
import { Background } from "../../components/BuildingBlocks/Background";
import { CRMButtonPrimary } from "../../components/CRMButtonPrimary/CRMButtonPrimary";
import { CRMCodecEditForm } from "../../components/CRMCodecEditForm/CRMCodecEditForm";
import { CRMParagraph } from "../../components/Simple/CRMParagraph/CRMParagraph";
import { ChangeStaffUserPasswordForm } from "../../../../domain/codecs/form/ChangeStaffUserPasswordForm";

export const CRMAdminChangeStaffUserPasswordContainer = (props: TContainerStateProps): JSX.Element => {

    const form = props.state.forms.change_staff_user_password_page;

    return (
        <CRMCardOutside borderRounding="right">
            <Background padding={CRMSpacing.LARGE} maxWidth="100%">
                <SpacingColumn spacing={CRMSpacing.LARGE}>
                    <CRMParagraph>
                        Change Staff User Password With Form Below
                    </CRMParagraph>
                    <CRMParagraph>
                        All fields are required <b>and password must be at least 16 characters long</b>
                    </CRMParagraph>
                    <CRMCodecEditForm 
                        codec={ChangeStaffUserPasswordForm.payload.codec} 
                        model={form.edited}
                        onChange={(edited) => props.dispatch({
                            type: "CHANGE_STAFF_USER_PASSWORD_FORM_CHANGE",
                            payload: {
                                ...form,
                                edited: {
                                    ...form.edited,
                                    ...edited,
                                }
                            }
                        })}
                        validationErrors={form.validationErrors}
                    />
                    <CRMButtonPrimary
                        label="Set Password"
                        onClick={() => props.dispatch({
                                type: "CHANGE_STAFF_USER_PASSWORD_FORM_SUBMIT",
                                payload: form
                            })
                        }
                    />
                    {form.status === "success" && <CRMParagraph>
                        PASSWORD SET
                    </CRMParagraph>}
                    {(form.status === "failure" || form.status === "validationError" || form.status === "unauthorised") && <CRMParagraph>
                        ERROR
                    </CRMParagraph>}
                    {form.status === "validationError" && <CRMParagraph>
                        VALIDATION ERROR
                    </CRMParagraph>}
                </SpacingColumn>
            </Background>
        </CRMCardOutside>
    );
};
